<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-12">
        <edit-profile-form v-bind:user="user"></edit-profile-form>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-2">
                <avatar
                  v-if="user && user.displayName"
                  class="photo"
                  :size="34"
                  :username="user.displayName"
                  :src="user.avatarUrl"></avatar>
              </div>
              <div class="col-sm-10">
                <h4 class="title">{{ user.displayName }}</h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <table class="table">
              <tbody>
                <tr>
                  <th>Joined</th>
                  <td>
                    <time :datetime="user.createdAt">{{ user.createdAt | moment("from", "now") }}</time>
                  </td>
                </tr>
                <tr>
                  <th>Updated</th>
                  <td>
                    <time :datetime="user.updatedAt">{{ user.updatedAt | moment("from", "now") }}</time>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditProfileForm from "./EditProfileForm.vue";
import Avatar from "vue-avatar";

export default {
  components: {
    EditProfileForm,
    Avatar
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    }
  }
};
</script>
<style></style>
